/*
Script to manage events of our custom file upload control.

To make it work like a charm, use this HTML structure :

<div class="custom-file-upload">
    <div class="custom-file-upload-button">FICHIER</div>
    <div class="custom-file-upload-text"></div>
    <input type="file" name="File" />
</div>

N.B. : Don't forget to include the /Content/form-custom-file-upload.css in your page ;)
*/

; (function () {
    'use strict';

    $('.custom-file-upload .form-control').on('change', function () {
        $(this).parents('.custom-file-upload').find('.custom-file-upload-text').html($(this).val());
    });
}());